/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Codec_Pcm_S16leInputs */



/**
* | output |
* | --- |
* | "PCM 16-bit" |
*
* @param {Audio_Embed_Export_Codec_Pcm_S16leInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_codec_pcm_s16le = /** @type {((inputs?: Audio_Embed_Export_Codec_Pcm_S16leInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Codec_Pcm_S16leInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("PCM 16 bits")
	if (locale === "de") return /** @type {LocalizedString} */ ("PCM 16-Bit")
	if (locale === "it") return /** @type {LocalizedString} */ ("PCM a 16 bit")
	if (locale === "ru") return /** @type {LocalizedString} */ ("PCM 16-бит")
	if (locale === "es") return /** @type {LocalizedString} */ ("PCM de 16 bits")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("PCM 16 位")
	if (locale === "ja") return /** @type {LocalizedString} */ ("PCM 16ビット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पीसीएम 16-बिट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("PCM de 16 bits")
	return /** @type {LocalizedString} */ ("PCM 16-bit")
});